import React from "react";
import Header from "./Header/Header.jsx";
import Body from "./Body/Body.jsx";
import Footer  from "./Footer/Footer.jsx";

export default function App(){
    return(
        <div>
            <Header />
            <Body />
            <Footer /> 
        </div>
    );
}